export const TICKET_HOLD_TTL_IN_SECONDS = 15 * 60;
